import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modalActive: false,
    modalSrc: '',
    timelineSortDesc: true,
    paths: {
      photoDir: '',
      videoDir: '',
      backendUrl: ''
    },
    photo_albums: [],
    videos: [],
    events: []
  },
  getters: {
    photo_dir: state => {
      return state.paths.photoDir
    },
    video_dir: state => {
      return state.paths.videoDir
    },
    backend_url: state => {
      return state.paths.backendUrl
    },
    photo_albums: state => {
      return state.photo_albums
    },
    videos: state => {
      return state.videos
    },
    events: state => {
      return state.events
    }
  },
  mutations: {
    setPaths: (state, payload) => {
      state.paths.photoDir = payload.photoDir
      state.paths.videoDir = payload.videoDir
      state.paths.backendUrl = payload.backendUrl
    },
    setPhotoAlbums: (state, payload) => {
      state.photo_albums = payload
    },
    setVideos: (state, payload) => {
      state.videos = payload
    },
    setEvents: (state, payload) => {
      state.events = payload
    }
  },
  actions: {
    loadPaths: ({ commit }) => {
      axios.get('/api/getpaths')
        .then(response => {
          commit('setPaths', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadPhotoAlbums: ({ commit }) => {
      axios.get('/api/getalbums')
        .then(response => {
          commit('setPhotoAlbums', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadVideos: ({ commit }) => {
      axios.get('/api/getvideos')
        .then(response => {
          commit('setVideos', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    },
    loadEvents: ({ commit }) => {
      axios.get('/api/getevents')
        .then(response => {
          commit('setEvents', response.data)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
})
